import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import Loading from '../components/core/loading';
import SessionContext from '../contexts/session';
import { activeFormId, redirectUserAfterLogin } from '../logic/auth';
import LandingPage1 from './landing/landing_v1';

export const getServerSideProps: GetServerSideProps = async (context) => {
    return {
        props: {
            query: context.query
        },
    };
};

export default function Home({ query }: InferGetServerSidePropsType<typeof getServerSideProps>): JSX.Element {
    const router = useRouter();
    const session = useContext(SessionContext);

    useEffect(() => {
        if (session.user.id) {
            redirectUserAfterLogin(session.user, router, undefined, session.user.formId || activeFormId);
        }
    }, [session.user]);
    return (
        <>
            {session.user.id ? <Loading /> : <LandingPage1 query={query} />}
        </>
    );
}
